// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".community-overview{position:relative}.community-overview__container{border-radius:5px}.community-overview__image-container{position:relative}.community-overview__image{aspect-ratio:16/10;border-radius:6px 6px 0 0;display:block;-o-object-fit:contain;object-fit:contain;-o-object-position:50% 50%;object-position:50% 50%;width:100%}.community-overview__description{font-size:14px;min-height:155px}.community-overview__heading{font-size:14px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
